<template>
  <body>
    <ModalAutores :autores="autores" v-show="modalAutores"
      @cerrar="cerrarModal"
      @recargar="recargarAutores"
      @AddAutor="otroAutor"/>
    <aside class="Blk-1">
    </aside>
    <aside class="Blk-2">
      <article class="Form">
        <div class="Blk-Campo">
          <p id="titReg">Documentos registrados</p>
          <select name="tesisY" id="" class="campo"
            :disabled = 'habBotAndCamp.habToD'
            v-model="tesisOdocSel" @change.prevent="mostrarTesisOdoc(tesisOdocSel._id)">
              <option v-for="nombreTesisY in nombresTesisY"
                :key="nombreTesisY._id"
                :value="nombreTesisY">
                {{nombreTesisY.titulo}}
              </option>
          </select>
        </div>
        <form @change="cambioFormToD">
          <div class="Blk-Campo">
            <p>Nombre completo*</p>
            <textarea name="nombre" class="campo" ref="nomCompleto" rows="2"
              :disabled = '!habBotAndCamp.habToD'
              v-model.trim="tesisOdocVista.titulo"
              spellcheck="false"
              autofocus>
            </textarea>
            <div class="minusculas">
              <button @click.prevent="lowCasePlus" id="lowCaseBtn"
                :disabled = '!habBotAndCamp.habToD'>AB->ab
              </button>
            </div>
          </div>
          <div class="Blk-Campo">
            <p>Autor(es)</p>
            <div class="campo" @change="cambioAutores" >{{autoresVista}}</div>
            <div class="botonesAut">
              <button class="botAut" @click.prevent="addAutor" :disabled = '!habBotAndCamp.habToD'>+</button>
              <button class="botAut" @click.prevent="delAutor" :disabled = '!habBotAndCamp.habToD'> - </button>
            </div>
          </div>
          <div class="Blk-Campo">
            <p>Ciudad</p>
              <input type="text" name="ciudad" class="campo"
                v-model.trim="tesisOdocVista.ciudad"
                :disabled = '!habBotAndCamp.habToD'>
            <p>País</p>
              <input type="text" name="pais" class="campo"
                v-model.trim="tesisOdocVista.pais"
                :disabled = '!habBotAndCamp.habToD'>
          </div>
          <div class="Blk-Campo">
            <p>Fecha</p>
            <input type="text" name="fecha" class="campo"
              v-model.trim="tesisOdocVista.fecha"
              :disabled = '!habBotAndCamp.habToD'>
            <p>Tipo documento</p>
            <select name="tipo" class="campo"
              v-model.trim="tesisOdocVista.tipoDoc"
              :disabled = '!habBotAndCamp.habToD'>
              <option value="1">Tesis</option>
              <option value="2">Seminario</option>
              <option value="3">Trabajo</option>
              <option value="4">Informe técnico</option>
              <option value="5">Monografía</option>
              <option value="6">Otro</option>
            </select>
          </div>
          <div class="Blk-Campo">
            <p>Institución</p>
              <input type="text" name="institucion" class="campo"
                v-model.trim="tesisOdocVista.institucion"
                :disabled = '!habBotAndCamp.habToD'>
          </div>
          <div class="Blk-Campo">
            <p>Resumen</p>
            <textarea name="resumen" id="resumen" class="campo"
              :disabled = '!habBotAndCamp.habToD'
              spellcheck="false"
              v-model.trim="tesisOdocVista.resumen">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Palabras clave</p>
            <textarea name="palabrasClave" class="campo" rows="2" id=""
              :disabled = '!habBotAndCamp.habToD'
              spellcheck="false"
              v-model.trim="tesisOdocVista.palsClave">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Área</p>
            <select name="area" class="campo"
              :disabled = '!habBotAndCamp.habToD'
              v-model.trim="tesisOdocVista.area">
              <option value="1">Antropoespeleología</option>
              <option value="2">Bioespeleología</option>
              <option value="3">Geoespeleología</option>
              <option value="4">Otras</option>
            </select>
            <p>Idioma</p>
            <input type="text" name="idioma" class="campo" list="idiomas" autocomplete="off"
              v-model.trim="tesisOdocVista.idioma"
              :disabled = '!habBotAndCamp.habToD'>
            <datalist id="idiomas">
              <option value="Español">Español</option>
              <option value="Francés">Francés</option>
              <option value="Italiano">Italiano</option>
              <option value="Inglés">Inglés</option>
              <option value="Japonés">Japonés</option>
            <option value="Portugués">Portugués</option>
            </datalist>
          </div>
          <div class="Blk-Campo">
            <div class="check">
              <p>Formato papel</p>
              <input type="checkbox" name="fPapel"
                v-model.trim="tesisOdocVista.papel"
                :disabled = '!habBotAndCamp.habToD'>
            </div>
            <div class="check">
              <p>Formato electrónico</p>
              <input type="checkbox" name="fElec"
                v-model.trim="tesisOdocVista.digital"
                :disabled = '!habBotAndCamp.habToD'>
            </div>
            <div class="check">
              <p>Información reservada</p>
              <input type="checkbox" name="privado"
                :disabled = '!habBotAndCamp.habToD'
                v-model.trim="tesisOdocVista.reservado">
            </div>
          </div>
        </form>
      </article>
      <aside class="Btns">
        <div> </div>
        <div> </div>
        <BotonesCRUD
        :desacMas="!habBotAndCamp.actMasToD"
        :desacEdit="!habBotAndCamp.actEdiToD"
        :desacMenos="!habBotAndCamp.actMenToD"
        :desacSave="!habBotAndCamp.actSavToD"
        @nuevo="nuevaTesisOdoc"
        @editar="editarTesisOdoc"
        @del="borrarTesisOdoc"
        @save="saveTesisOdoc"
        />
      </aside>
    </aside>
  </body>
</template>

<script>
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import BotonesCRUD from '../components/BotonesCRUD.vue'
import ModalAutores from '../components/ModalAutores.vue'
import axios from 'axios'
export default {
  name: 'FormTesisY',
  components: { BotonesCRUD, ModalAutores },
  created () {
    this.token = this.usuarioEnSesion.tokenUser
    // Trae los datos de los documentos guardados en la tabla tesisyseminarios
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.getNombresTesisYdocs()
    this.getAutores()
    this.activaModo('INI')
  },
  data () {
    return {
      nombresTesisY: [],
      tesisOdocVista: {},
      tesisOdocVistaBkUp: {},
      tesisOdocSel: [],
      tesisOdocSelBkUp: [],
      habBotAndCamp: {
        actMasToD: false,
        actEdiToD: false,
        actMenToD: false,
        actSavToD: false,
        habToD: false
      },
      modoBkUp: [],
      IsModoSalirMasToD: false,
      IsModoSalirEdiToD: false,
      URLbase: '',
      token: '',
      autores: [],
      modalAutores: false,
      autoresTesisY: [],
      autoresTesisYBkUp: []
    }
  },
  methods: {
    async getNombresTesisYdocs () {
      try {
        const url = `${this.URLbase}/tesisY/listaTesisY`
        const res = await axios.get(url)
        this.nombresTesisY = res.data
      } catch (error) {
        alert(error)
      }
    },
    async getDatosTesisOdoc (IdTesisOdoc) {
      try {
        const url = `${this.URLbase}/tesisY/getTesisYData`
        const tesisYId = { _id: IdTesisOdoc }
        const res = await axios.post(url, tesisYId)
        this.tesisOdocVista = res.data
        this.autoresTesisY = res.data.autores
      } catch (error) {
        alert(error)
      }
    },
    mostrarTesisOdoc (IdTesisOdoc) {
      this.getDatosTesisOdoc(IdTesisOdoc)
      this.activaModo('ToDS')
    },
    setFocus () {
      setTimeout(() => { this.$refs.nomCompleto.focus() }, 300)
    },
    blanquearTesisOdocVista () {
      this.tesisOdocVista = {}
      this.tesisOdocSel = []
      this.autoresTesisY = []
    },
    nuevaTesisOdoc () {
      this.IsModoSalirMasToD = !this.IsModoSalirMasToD
      if (this.IsModoSalirMasToD) {
        this.tesisOdocVistaBkUp = JSON.parse(JSON.stringify(this.tesisOdocVista))
        this.autoresTesisYBkUp = JSON.parse(JSON.stringify(this.autoresTesisY))
        this.tesisOdocSelBkUp = JSON.parse(JSON.stringify(this.tesisOdocSel))
        this.tesisOdocVista = {}
        this.activaModo('ToDMAS')
        this.autoresTesisY = []
        this.tesisOdocSel = []
        this.setFocus()
      } else {
        this.tesisOdocSel = this.tesisOdocSelBkUp
        if (this.tesisOdocSel.titulo) {
          this.tesisOdocVista = JSON.parse(JSON.stringify(this.tesisOdocVistaBkUp))
          this.autoresTesisY = JSON.parse(JSON.stringify(this.autoresTesisYBkUp))
          this.activaModo('ToDS')
        } else {
          this.blanquearTesisOdocVista()
          this.activaModo('INI')
        }
      }
    },
    editarTesisOdoc () {
      this.IsModoSalirEdiToD = !this.IsModoSalirEdiToD
      if (this.IsModoSalirEdiToD) {
        this.tesisOdocVistaBkUp = JSON.parse(JSON.stringify(this.tesisOdocVista))
        this.autoresTesisYBkUp = JSON.parse(JSON.stringify(this.autoresTesisY))
        this.tesisOdocSelBkUp = this.tesisOdocSel
        this.activaModo('ToDEDI')
      } else {
        this.tesisOdocVista = JSON.parse(JSON.stringify(this.tesisOdocVistaBkUp))
        this.autoresTesisY = JSON.parse(JSON.stringify(this.autoresTesisYBkUp))
        this.tesisOdocSel = this.tesisOdocSelBkUp
        this.activaModo('ToDS')
        // this.autoresVista1()
      }
    },
    cambioFormToD () {
      if (this.IsModoSalirMasToD && this.minDataToD) {
        this.activaModo('ToDMASs')
      }
      if (this.IsModoSalirEdiToD && this.minDataToD) {
        this.activaModo('ToDEDIs')
      }
    },
    async borrarTesisOdoc () {
      const response = await this.$root.alertJoa(
        'Estás a punto de borrar el registro de este documento. Esta acción no puede revertirse ¿Quieres continuar?',
        'W', 'C'
      )
      if (response === 'borrar') {
        try {
          const url = `${this.URLbase}/tesisY/borrarDoc`
          const TesisYId = { _id: this.tesisOdocVista._id }
          axios.post(url, TesisYId, {
            headers: {
              authorization: this.token
            }
          })
            .then(result => {
              switch (result.status) {
                case 200:
                  this.blanquearTesisOdocVista()
                  this.alertJoa('¡Registro borrado con éxito!', 'S')
                  this.getNombresTesisYdocs()
                  break
                case 500:
                  this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
                  break
                default:
                  this.alertJoa('Algo salió mal, intenta otra vez', 'E')
              }
            })
            .catch(error => {
              console.log(error)
              this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
            })
        } catch (error) {
          alert(error)
        }
      }
    },
    async saveTesisOdoc () {
      this.tesisOdocVista.autores = this.autoresTesisY
      try {
        const url = `${this.URLbase}/tesisY/save`
        const tesisY = this.tesisOdocVista
        await axios.post(url, tesisY, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error al guardar, intenta otra vez', 'E')
                break
              case 'success':
                this.alertJoa('Datos guardados con éxito!', 'S')
                break
            }
            this.getNombresTesisYdocs()
          })
      } catch (error) {
        alert(error)
      }
      this.IsModoSalirMasToD = false
      this.IsModoSalirEdiToD = false
      this.blanquearTesisOdocVista()
      this.activaModo('INI')
    },
    async getAutores () {
      try {
        const url = `${this.URLbase}/autores/listAutores`
        const res = await fetch(url)
        this.autores = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    // Abre ventana modal para vincular un autor a la tesis o al documento.
    // Si no está, permite escribir y guardar un nuevo autor.
    addAutor () {
      if (this.tesisOdocVista.titulo) { this.modalAutores = true }
    },
    recargarAutores () {
      this.getAutores()
    },
    // Elimina el último autor asociado a la ponencia
    delAutor () {
      this.autoresTesisY.pop()
    },
    // Añade los autores en orden de una ponencia
    otroAutor (autorRecibido) {
      if (!this.autoresTesisY.includes(autorRecibido)) {
        this.autoresTesisY.push(autorRecibido)
      }
    },
    cerrarModal () {
      this.modalAutores = false
    },
    activaModo (modo) {
      switch (modo) {
        case 'INI':
          this.confModo = [1, 0, 0, 0, 0]
          break
        case 'ToDS':
          this.confModo = [1, 1, 1, 0, 0]
          break
        case 'ToDMAS':
          this.confModo = [1, 0, 0, 0, 1]
          break
        case 'ToDMASs':
          this.confModo = [1, 0, 0, 1, 1]
          break
        case 'ToDEDI':
          this.confModo = [0, 1, 0, 0, 1]
          break
        case 'ToDEDIs':
          this.confModo = [0, 1, 0, 1, 1]
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        this.confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    },
    lowCasePlus () {
      this.tesisOdocVista.titulo = this.tesisOdocVista.titulo.toLowerCase()
      this.tesisOdocVista.titulo = this.tesisOdocVista.titulo.replaceAll(/\n|\r/g, ' ')
      this.tesisOdocVista.titulo = this.tesisOdocVista.titulo.replaceAll('  ', ' ')
      this.tesisOdocVista.resumen = this.tesisOdocVista.resumen.replaceAll(/\n|\r/g, ' ')
      this.tesisOdocVista.resumen = this.tesisOdocVista.resumen.replaceAll('  ', ' ')
    }
  },

  computed: {
    autoresVista () {
      // const A = this.autoresTesisY.map((e) => this.autores.find((autor) => autor._id === e))
      return this.autoresTesisY.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ')
    },
    minDataToD () {
      return (this.tesisOdocVista.titulo && !!this.autoresTesisY)
    },
    habilitaDivAutores () {
      if (!this.habBotAndCamp.habToD) {
        return 'pointer-events: none;'
      } else {
        return ''
      }
    },
    ...mapState(['usuarioEnSesion'])
  },
  watch: {
    autoresVista () {
      if ((this.IsModoSalirEdiToD || this.IsModoSalirMasToD) && this.autoresTesisY.length > 0) {
        this.cambioFormToD()
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
aside.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 2%;
}
article.Form {
  padding-top: 20px;
}
.Btns {
  /* display: grid; */
  padding-left: 20px;
  padding-top: 20px;
  position: sticky; /* no funciona */
}
.Blk-Campo{
  width: 100%;
  /* flex:20; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.Blk-Campo p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.campo{
  height: auto;
  min-height: 26px;
  width: auto;
  min-width: 70px;
  /* margin-left: 10px; */
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: var(--bo-cam);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  text-align: left;
}
.campo:focus{
  outline-color: var(--az-ico);
}
.check{
  display: flex;
  margin-top: 2%;
}
.check p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  padding-right: 4px;
  max-width: 150px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.botAut{
  height: auto;
  min-height: 26px;
  width: 26px;
  font-size: 18px;
}
#titReg{
  font-weight: bold;
}
input[type=checkbox] {
  transform: scale(1.2);
}
@media screen and (max-width: 576px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
  }
  article.Form {
    padding-top: 10px;
    overflow-y: scroll;
  }
  .Blk-Campo {
    width:94%;
    flex-direction: column;
    /* align-items:flex-start; */
    align-items:stretch;
    margin-left:3%;
  }
  .Blk-Campo p{
    max-width: 80%;
  }
  .campo{
    width: 100%;
    margin: 0 0 0 0;
  }
  .check{
    width: 43%;
    justify-content: space-between;
    margin-top: 6px;
    /* border: solid 1px orange; */
  }
  .Btns {
    padding: 0 2.5% 2% 2.5%;
    /* background-color:  rgba(209, 208, 183, 0.911); */
  }
  .minusculas{
    align-self: end;
    margin-right: 2%;
  }
  textarea {
    resize: none;
  }
  textarea.campo, input.campo, div.campo{
    width: 97%;
    margin-left:0%;
  }
  .botonesAut{
    align-self: flex-end;
    margin-right: 2.5%;
  }
}
</style>
